import { config } from '_config';

import {
  FIELDS_KEYS,
  MONTH_OPTIONS,
  DAY_OPTIONS,
  ORG_TYPE_OPTIONS,
  OTHER_ORG_TYPE_OPTIONS,
  EXTENSION_REASON_OPTIONS,
  STATE_OPTIONS,
  LETTERS_TYPE,
  LOGO_CATEGORY,
  LOGO_USE,
  COUNTRY_OPTIONS,
} from '_constants/forms';

import { TRADEMARK_SERVICE_KEYS } from '_constants/trademarkServices';

import { getValidationRules } from '_helpers/forms/rules';

const fieldProps = {
  [FIELDS_KEYS.firstName]: {
    name: FIELDS_KEYS.firstName,
    label: 'First Name',
    placeholder: 'Enter First Name',
    required: true,
    onKeyPress: (event) => {
      if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.fullName]: {
    name: FIELDS_KEYS.fullName,
    label: 'Full Name',
    placeholder: 'Full Name',
    required: true,
    onKeyPress: (event) => {
      if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.middleName]: {
    name: FIELDS_KEYS.middleName,
    label: 'Middle Name (optional)',
    required: false,
    onKeyPress: (event) => {
      if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.lastName]: {
    name: FIELDS_KEYS.lastName,
    label: 'Last Name',
    placeholder: 'Enter Last Name',
    required: true,
    onKeyPress: (event) => {
      if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.subject]: {
    name: FIELDS_KEYS.subject,
    label: 'Subject',
    placeholder: 'Subject',
    required: true,
  },
  [FIELDS_KEYS.message]: {
    name: FIELDS_KEYS.message,
    label: 'Message',
    placeholder: 'Type your message',
    required: true,
  },
  [FIELDS_KEYS.phone]: {
    name: FIELDS_KEYS.phone,
    label: 'Phone',
    required: true,
    type: 'phone',
    mask: '(000) 000-0000',
    placeholder: '(123) 456-7890',
  },
  [FIELDS_KEYS.email]: {
    name: FIELDS_KEYS.email,
    label: 'Email',
    placeholder: 'Enter Email Address',
    required: true,
    type: 'email',
  },
  [FIELDS_KEYS.address]: {
    name: FIELDS_KEYS.address,
    required: true,
    label: 'Address',
    placeholder: 'Enter Address',
  },
  [FIELDS_KEYS.city]: {
    name: FIELDS_KEYS.city,
    required: true,
    label: 'City',
    placeholder: 'Enter City Name',
    onKeyPress: (event) => {
      if (!/[ a-zA-Z/-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.state]: {
    name: FIELDS_KEYS.state,
    required: true,
    label: 'State/Province/Region',
    placeholder: 'Select a state',
    options: STATE_OPTIONS,
  },
  [FIELDS_KEYS.countryOfCitizenship]: {
    name: FIELDS_KEYS.countryOfCitizenship,
    required: true,
    label: 'Country of Citizenship',
    options: COUNTRY_OPTIONS,
  },
  [FIELDS_KEYS.zip]: {
    name: FIELDS_KEYS.zip,
    required: true,
    label: 'ZIP / Postal Code',
    placeholder: 'Enter ZIP / Postal Code',
    maxLength: '5',
    onKeyPress: (event) => {
      if (!/[0-9]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.trademarkType]: {
    name: FIELDS_KEYS.trademarkType,
    required: true,
    options: [
      {
        label: 'Name',
        value: 'NAME',
      },
      {
        label: 'Slogan',
        value: 'SLOGAN',
      },
      {
        label: 'Logo',
        value: 'LOGO',
      },
    ],
  },
  [FIELDS_KEYS.markDesc]: {
    name: FIELDS_KEYS.markDesc,
    required: true,
  },
  [FIELDS_KEYS.trademarkName]: {
    name: FIELDS_KEYS.trademarkName,
    required: true,
    placeholder: 'Enter the mark',
  },
  [FIELDS_KEYS.literalElements]: {
    name: FIELDS_KEYS.literalElements,
    required: true,
    label: 'Description of your logo',
    placeholder: 'Enter the description of your logo',
  },
  [FIELDS_KEYS.logoColoredVariety]: {
    name: FIELDS_KEYS.logoColoredVariety,
    labelOff: 'No',
    labelOn: 'Yes',
  },
  [FIELDS_KEYS.colorsInLogo]: {
    name: FIELDS_KEYS.colorsInLogo,
    required: true,
    label: 'A list of the colors that appear in your logo',
    placeholder: 'Enter the list of the colors',
  },
  [FIELDS_KEYS.logoFile]: {
    name: FIELDS_KEYS.logoFile,
    required: true,
    type: 'file',
    label: 'Upload logo file',
    // accept: '.png,.jpg,.jpeg,.pdf',
  },
  [FIELDS_KEYS.isIncludeLivingPersonName]: {
    name: FIELDS_KEYS.isIncludeLivingPersonName,
    labelOff: 'No',
    labelOn: 'Yes',
  },
  [FIELDS_KEYS.isIncludeNicknameName]: {
    name: FIELDS_KEYS.isIncludeNicknameName,
    labelOff: 'No',
    labelOn: 'Yes',
  },
  [FIELDS_KEYS.ownName]: {
    name: FIELDS_KEYS.ownName,
    required: true,
    label: 'Legal Name',
    placeholder: 'Enter the legal name',
  },
  [FIELDS_KEYS.isOtherLivingName]: {
    name: FIELDS_KEYS.isOtherLivingName,
    labelOff: 'No',
    labelOn: 'Yes',
  },
  [FIELDS_KEYS.includeTranslationWords]: {
    name: FIELDS_KEYS.includeTranslationWords,
    labelOff: 'No',
    labelOn: 'Yes',
  },
  [FIELDS_KEYS.translation]: {
    name: FIELDS_KEYS.translation,
    required: true,
    label: 'English translation',
    placeholder: 'Enter the English translation or transliteration',
  },
  [FIELDS_KEYS.firstUseAnywhereYear]: {
    name: FIELDS_KEYS.firstUseAnywhereYear,
    required: true,
    placeholder: 'Year',
  },
  [FIELDS_KEYS.firstUseAnywhereMonth]: {
    name: FIELDS_KEYS.firstUseAnywhereMonth,
    required: true,
    label: 'First Use Anywhere',
    placeholder: 'Month',
    options: MONTH_OPTIONS,
  },
  [FIELDS_KEYS.firstUseAnywhereDay]: {
    name: FIELDS_KEYS.firstUseAnywhereDay,
    required: true,
    placeholder: 'Day',
    options: DAY_OPTIONS,
  },
  [FIELDS_KEYS.firstUseInCommerceYear]: {
    name: FIELDS_KEYS.firstUseInCommerceYear,
    required: true,
    placeholder: 'Year',
  },
  [FIELDS_KEYS.firstUseInCommerceMonth]: {
    name: FIELDS_KEYS.firstUseInCommerceMonth,
    required: true,
    label: 'First Use In Commerce',
    placeholder: 'Month',
    options: MONTH_OPTIONS,
  },
  [FIELDS_KEYS.firstUseInCommerceDay]: {
    name: FIELDS_KEYS.firstUseInCommerceDay,
    required: true,
    placeholder: 'Day',
    options: DAY_OPTIONS,
  },
  [FIELDS_KEYS.currentTrademark]: {
    name: FIELDS_KEYS.currentTrademark,
    labelOff: 'No',
    labelOn: 'Yes',
  },
  [FIELDS_KEYS.individualOrgOrInd]: {
    name: FIELDS_KEYS.individualOrgOrInd,
    required: true,
    options: [
      {
        label: 'Individual',
        value: 'Individual',
      },
      {
        label: 'Organization',
        value: 'Organization',
      },
    ],
  },
  [FIELDS_KEYS.isNonUsBased]: {
    name: FIELDS_KEYS.isNonUsBased,
    required: true,
    options: [
      {
        label: 'US Based',
        value: 'USBased',
      },
      {
        label: 'Non US Based',
        value: 'NonUSBased',
      },
    ],
  },
  [FIELDS_KEYS.orgName]: {
    name: FIELDS_KEYS.orgName,
    required: true,
    label: 'Organization Name',
    placeholder: 'Organization Name',
    onKeyPress: (event) => {
      if (!/[ a-zA-Z0-9/-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.orgType]: {
    name: FIELDS_KEYS.orgType,
    required: true,
    label: 'Organization Type',
    placeholder: 'Organization Type',
    options: ORG_TYPE_OPTIONS,
  },
  [FIELDS_KEYS.otherOrgType]: {
    name: FIELDS_KEYS.otherOrgType,
    placeholder: 'Specify Type',
    required: true,
    options: OTHER_ORG_TYPE_OPTIONS,
  },
  [FIELDS_KEYS.orgState]: {
    name: FIELDS_KEYS.orgState,
    required: true,
    label: 'State of Formation',
    placeholder: 'State of Formation',
    options: STATE_OPTIONS,
  },
  [FIELDS_KEYS.formationCountry]: {
    name: FIELDS_KEYS.formationCountry,
    required: true,
    label: 'Country of Citizenship',
    options: COUNTRY_OPTIONS,
  },
  [FIELDS_KEYS.orgPosition]: {
    name: FIELDS_KEYS.orgPosition,
    required: true,
    label: 'Position',
    placeholder: 'CEO',
    onKeyPress: (event) => {
      if (!/[ a-zA-Z/-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.goods]: {
    name: FIELDS_KEYS.goods,
    labelOff: 'Services',
    labelOn: 'Goods',
  },
  [FIELDS_KEYS.goodsCategory]: {
    name: FIELDS_KEYS.goodsCategory,
    required: true,
    placeholder: 'Start typing to search categories…',
  },
  [FIELDS_KEYS.description]: {
    name: FIELDS_KEYS.description,
    required: true,
    placeholder: 'Enter additional description',
  },
  [FIELDS_KEYS.processingOption]: {
    name: FIELDS_KEYS.processingOption,
    required: true,
  },
  [FIELDS_KEYS.productCode]: {
    name: FIELDS_KEYS.productCode,
    required: true,
  },
  [FIELDS_KEYS.rush]: {
    name: FIELDS_KEYS.rush,
  },
  [FIELDS_KEYS.cardNumber]: {
    name: FIELDS_KEYS.cardNumber,
    required: true,
    label: 'Card Number',
    placeholder: '0000 0000 0000 0000',
  },
  [FIELDS_KEYS.cvc]: {
    name: FIELDS_KEYS.cvc,
    // type: 'password',
    required: true,
    label: 'CVC/CVV',
    placeholder: 'CVC',
    maxLength: '4',
    onKeyPress: (event) => {
      if (!/[\d{3,4}]/.test(event.key)) {
        event.preventDefault();
      }
    },
  },
  [FIELDS_KEYS.cardMonth]: {
    name: FIELDS_KEYS.cardMonth,
    required: true,
    label: 'Expiration date',
    placeholder: 'Month',
    options: MONTH_OPTIONS,
  },
  [FIELDS_KEYS.cardYear]: {
    name: FIELDS_KEYS.cardYear,
    required: true,
    placeholder: 'Year',
  },
  [FIELDS_KEYS.billingAddressAddress1]: {
    name: FIELDS_KEYS.billingAddressAddress1,
    required: true,
    label: 'Billing Address',
    placeholder: 'Enter Address',
  },
  [FIELDS_KEYS.billingAddressCity]: {
    name: FIELDS_KEYS.billingAddressCity,
    required: true,
    label: 'City',
    placeholder: 'Enter City Name',
    onKeyPress: (event) => {
      if (!/[ a-zA-Z/-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.billingAddressState]: {
    name: FIELDS_KEYS.billingAddressState,
    required: true,
    label: 'State',
    placeholder: 'Select a state',
    options: STATE_OPTIONS,
  },
  [FIELDS_KEYS.billingAddressZip]: {
    name: FIELDS_KEYS.billingAddressZip,
    required: true,
    label: 'ZIP Code',
    placeholder: 'Enter ZIP Code',
    maxLength: '5',
    onKeyPress: (event) => {
      if (!/[0-9]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.agreeWithTerms]: {
    name: FIELDS_KEYS.agreeWithTerms,
    label:
      'I accept the terms. I have read, understand, & agree to the terms of service.',
  },
  [FIELDS_KEYS.isSerialNumber]: {
    name: FIELDS_KEYS.isSerialNumber,
    labelOff: 'Don’t now it? Click here',
    labelOn: 'Serial Number',
  },
  [FIELDS_KEYS.serialNumber]: {
    name: FIELDS_KEYS.serialNumber,
    required: true,
  },
  [FIELDS_KEYS.markOwnerFirstName]: {
    name: FIELDS_KEYS.markOwnerFirstName,
    placeholder: 'Enter First Name',
    required: true,
    onKeyPress: (event) => {
      if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.markOwnerLastName]: {
    name: FIELDS_KEYS.markOwnerLastName,
    placeholder: 'Enter Last Name',
    required: true,
    onKeyPress: (event) => {
      if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.markOwnerPhone]: {
    name: FIELDS_KEYS.markOwnerPhone,
    required: true,
    type: 'phone',
    mask: '(000) 000-0000',
    placeholder: '(123) 456-7890',
  },
  [FIELDS_KEYS.markOwnerEmail]: {
    name: FIELDS_KEYS.markOwnerEmail,
    placeholder: 'Enter Email Address',
    required: true,
    type: 'email',
  },
  [FIELDS_KEYS.isAddressSame]: {
    name: FIELDS_KEYS.isAddressSame,
    labelOff: 'No',
    labelOn: 'Yes',
  },
  [FIELDS_KEYS.isNewAddress]: {
    name: FIELDS_KEYS.isNewAddress,
    labelOff: 'No',
    labelOn: 'Yes',
  },
  [FIELDS_KEYS.newAddress]: {
    name: FIELDS_KEYS.newAddress,
    required: true,
    label: 'Address',
    placeholder: 'Enter Address',
  },
  [FIELDS_KEYS.newCity]: {
    name: FIELDS_KEYS.newCity,
    required: true,
    label: 'City',
    placeholder: 'Enter City Name',
    onKeyPress: (event) => {
      if (!/[ a-zA-Z/-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.newState]: {
    name: FIELDS_KEYS.newState,
    required: true,
    label: 'State/Province/Region',
    placeholder: 'Select a state',
    options: STATE_OPTIONS,
  },
  [FIELDS_KEYS.newZip]: {
    name: FIELDS_KEYS.newZip,
    required: true,
    label: 'ZIP / Postal Code',
    placeholder: 'Enter ZIP / Postal Code',
    maxLength: '5',
    onKeyPress: (event) => {
      if (!/[0-9]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.isNewDrawing]: {
    name: FIELDS_KEYS.isNewDrawing,
    labelOff: 'No',
    labelOn: 'Yes',
  },
  [FIELDS_KEYS.isMarkOwnerSame]: {
    name: FIELDS_KEYS.isMarkOwnerSame,
    labelOff: 'No',
    labelOn: 'Yes',
  },
  [FIELDS_KEYS.isNewMarkOwner]: {
    name: FIELDS_KEYS.isNewMarkOwner,
    labelOff: 'No',
    labelOn: 'Yes',
  },
  [FIELDS_KEYS.newMarkOwnerFirstName]: {
    name: FIELDS_KEYS.newMarkOwnerFirstName,
    placeholder: 'Enter First Name',
    required: true,
    onKeyPress: (event) => {
      if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.newMarkOwnerLastName]: {
    name: FIELDS_KEYS.newMarkOwnerLastName,
    placeholder: 'Enter Last Name',
    required: true,
    onKeyPress: (event) => {
      if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.newMarkOwnerDescription]: {
    name: FIELDS_KEYS.newMarkOwnerDescription,
    required: true,
    placeholder: 'Provide an explanation for the change',
  },
  [FIELDS_KEYS.isNoticeOfAllowanceCovered]: {
    name: FIELDS_KEYS.isNoticeOfAllowanceCovered,
    labelOff: 'No',
    labelOn: 'Yes',
  },
  [FIELDS_KEYS.classesOrGoodsNotCovered]: {
    name: FIELDS_KEYS.classesOrGoodsNotCovered,
    required: true,
  },
  [FIELDS_KEYS.isExtensionOnClasses]: {
    name: FIELDS_KEYS.isExtensionOnClasses,
    labelOff: 'No',
    labelOn: 'Yes',
  },
  [FIELDS_KEYS.itemsCovered]: {
    name: FIELDS_KEYS.itemsCovered,
    required: true,
  },
  [FIELDS_KEYS.itemsExtension]: {
    name: FIELDS_KEYS.itemsExtension,
    required: true,
  },
  [FIELDS_KEYS.classType]: {
    name: FIELDS_KEYS.classType,
    required: true,
    options: [
      {
        label: 'Goods',
        value: 'GOODS',
      },
      {
        label: 'Service',
        value: 'SERVICE',
      },
      {
        label: 'Both',
        value: 'BOTH',
      },
    ],
  },
  [FIELDS_KEYS.isSpecimenNeeded]: {
    name: FIELDS_KEYS.isSpecimenNeeded,
    required: true,
    options: [
      {
        label: 'Yes',
        value: 'YES',
      },
      {
        label: 'No',
        value: 'NO',
      },
      {
        label: "I don't know",
        value: 'NO_ANSWER',
      },
    ],
  },
  [FIELDS_KEYS.isClassesInUse]: {
    name: FIELDS_KEYS.isClassesInUse,
    required: true,
    options: [
      {
        label:
          'Yes, on all of the goods or services listed in the registration',
        value: 'YES_ON_ALL',
      },
      {
        label:
          'Yes, on some of the goods or services listed in the registration',
        value: 'YES_ON_SOME',
      },
      {
        label: 'No',
        value: 'NO',
      },
    ],
  },
  [FIELDS_KEYS.goodsServiceDetail]: {
    name: FIELDS_KEYS.goodsServiceDetail,
    required: true,
    placeholder: 'Enter additional description',
  },
  [FIELDS_KEYS.isSpecimenFile]: {
    name: FIELDS_KEYS.isSpecimenFile,
    labelOff: 'URL',
    labelOn: 'File',
  },
  [FIELDS_KEYS.specimenFile]: {
    name: FIELDS_KEYS.specimenFile,
    required: true,
    type: 'file',
    label: 'Upload specimen file',
    // accept: '.png,.jpg,.jpeg,.pdf',
  },
  [FIELDS_KEYS.specimenUrl]: {
    name: FIELDS_KEYS.specimenUrl,
    required: true,
    placeholder: 'Enter the specimen URL',
  },
  [FIELDS_KEYS.isExtendedInThePast]: {
    name: FIELDS_KEYS.isExtendedInThePast,
    labelOff: 'No',
    labelOn: 'Yes',
  },
  [FIELDS_KEYS.timesDeadlineWasExtended]: {
    name: FIELDS_KEYS.timesDeadlineWasExtended,
    required: true,
    onKeyPress: (event) => {
      if (!/[0-9]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.extensionReason]: {
    name: FIELDS_KEYS.extensionReason,
    placeholder: 'Product or service research or development',
    required: true,
    options: EXTENSION_REASON_OPTIONS,
  },
  [FIELDS_KEYS.extensionReasonOther]: {
    name: FIELDS_KEYS.extensionReasonOther,
    required: true,
  },
  [FIELDS_KEYS.service]: {
    name: FIELDS_KEYS.service,
    required: true,
    options: [
      {
        label: "I didn't Respond to an Office Action",
        value: TRADEMARK_SERVICE_KEYS.officeActionResponse,
      },
      {
        label: "I didn't File a Statement of Use",
        value: TRADEMARK_SERVICE_KEYS.statementOfUse,
      },
    ],
  },
  [FIELDS_KEYS.officeActionStatus]: {
    name: FIELDS_KEYS.officeActionStatus,
    required: true,
    options: [
      {
        label:
          'Only Procedural Issue(s) (e.g., disclaimer, specimen of use, description of mark, etc.)',
        value: 'PROCEDURAL_ISSUE_OFFICE_ACTION_TYPE',
      },
      {
        label:
          'It was Refused Registration (e.g., blocking mark, descriptive, last name, etc.)',
        value: 'REFUSED_REGISTRATION_OFFICE_ACTION_TYPE',
      },
    ],
  },
  [FIELDS_KEYS.statementOfUseStatus]: {
    name: FIELDS_KEYS.statementOfUseStatus,
    required: true,
    options: [
      {
        label: 'Yes, it is in use. File my Statement of Use',
        value: 'TRADEMARK_IN_USE',
      },
      {
        label: 'No, it is not in use. File an my Extension of Time',
        value: 'TRADEMARK_NOT_IN_USE',
      },
    ],
  },
  [FIELDS_KEYS.isOfficeAction]: {
    name: FIELDS_KEYS.isOfficeAction,
  },
  [FIELDS_KEYS.isKeepAlive]: {
    name: FIELDS_KEYS.isKeepAlive,
  },
  [FIELDS_KEYS.isCertifiedCopy]: {
    name: FIELDS_KEYS.isCertifiedCopy,
  },
  [FIELDS_KEYS.privacyPackage]: {
    name: FIELDS_KEYS.privacyPackage,
    required: true,
  },
  [FIELDS_KEYS.logoName]: {
    name: FIELDS_KEYS.logoName,
    required: true,
    label: 'Exact Logo Wording/Business Name',
  },
  [FIELDS_KEYS.slogan]: {
    name: FIELDS_KEYS.slogan,
    label: 'Tagline/Slogan (Optional)',
  },
  [FIELDS_KEYS.businessIndustry]: {
    name: FIELDS_KEYS.businessIndustry,
    required: true,
    label: 'Business Industry',
  },
  [FIELDS_KEYS.businessDescription]: {
    name: FIELDS_KEYS.businessDescription,
    required: true,
    label: 'Business Description',
  },
  [FIELDS_KEYS.businessProducts]: {
    name: FIELDS_KEYS.businessProducts,
    required: true,
    label: 'Business Products/Services',
  },
  [FIELDS_KEYS.targetAudience]: {
    name: FIELDS_KEYS.targetAudience,
    required: true,
    label: 'Target Audience for Customers',
  },
  [FIELDS_KEYS.businessWebsite]: {
    name: FIELDS_KEYS.businessWebsite,
    label: 'Business Website (Optional)',
  },
  [FIELDS_KEYS.lettersType]: {
    name: FIELDS_KEYS.lettersType,
    required: true,
    label: 'How do you want your logo to be written ?',
    options: [
      {
        label: 'As it is (as shared above)',
        value: LETTERS_TYPE.AS_IT_IS,
      },
      {
        label: 'In CAPITAL LETTERS',
        value: LETTERS_TYPE.UPPERCASE,
      },
      {
        label: 'In small letters',
        value: LETTERS_TYPE.LOWERCASE,
      },
    ],
  },
  [FIELDS_KEYS.customersConception]: {
    name: FIELDS_KEYS.customersConception,
    required: true,
  },
  [FIELDS_KEYS.logoCategory]: {
    name: FIELDS_KEYS.logoCategory,
    required: true,
    label: 'Logo Categories',
    options: [
      {
        label: 'Just font (Just font without any symbolic intervention)',
        value: LOGO_CATEGORY.JUST_FONT,
        imgSrc: `${config.basePath}/images/${LOGO_CATEGORY.JUST_FONT}.jpg`,
      },
      {
        label:
          'Font + Meaning (A font with a tweak that symbolize company/product/service)',
        value: LOGO_CATEGORY.FONT_WITH_MEANING,
        imgSrc: `${config.basePath}/images/${LOGO_CATEGORY.FONT_WITH_MEANING}.jpg`,
      },
      {
        label: 'Handmade (A calligraphic, handwritten or script font)',
        value: LOGO_CATEGORY.HANDMADE,
        imgSrc: `${config.basePath}/images/${LOGO_CATEGORY.HANDMADE}.jpg`,
      },
      {
        label: 'Initials (Monogram with company name initials)',
        value: LOGO_CATEGORY.INITIALS,
        imgSrc: `${config.basePath}/images/${LOGO_CATEGORY.INITIALS}.jpg`,
      },
      {
        label: 'Abstract graphic',
        value: LOGO_CATEGORY.ABSTRACT_GRAPHIC,
        imgSrc: `${config.basePath}/images/${LOGO_CATEGORY.ABSTRACT_GRAPHIC}.jpg`,
      },
      {
        label: 'Silhouette (A detailed illustrated silhouette)',
        value: LOGO_CATEGORY.SILHOUETTE,
        imgSrc: `${config.basePath}/images/${LOGO_CATEGORY.SILHOUETTE}.jpg`,
      },
      {
        label: 'Geometric symbol',
        value: LOGO_CATEGORY.GEOMETRIC_SYMBOL,
        imgSrc: `${config.basePath}/images/${LOGO_CATEGORY.GEOMETRIC_SYMBOL}.jpg`,
      },
      {
        label: 'Illustrated symbol',
        value: LOGO_CATEGORY.ILLUSTRATED_SYMBOL,
        imgSrc: `${config.basePath}/images/${LOGO_CATEGORY.ILLUSTRATED_SYMBOL}.jpg`,
      },
      {
        label:
          'Emblem and Crests (Enclosed logo with just text or including graphics)',
        value: LOGO_CATEGORY.EMBLEM_AND_CRESTS,
        imgSrc: `${config.basePath}/images/${LOGO_CATEGORY.EMBLEM_AND_CRESTS}.jpg`,
      },
      {
        label: 'Mascot (A character representing your Company)',
        value: LOGO_CATEGORY.MASCOT,
        imgSrc: `${config.basePath}/images/${LOGO_CATEGORY.MASCOT}.jpg`,
      },
    ],
  },
  [FIELDS_KEYS.logoUse]: {
    name: FIELDS_KEYS.logoUse,
    required: true,
    label: 'Where will you use your Logo?',
    options: [
      {
        label: 'Website',
        value: LOGO_USE.WEBSITE,
      },
      {
        label: 'Business Stationery Printing',
        value: LOGO_USE.BUSINESS_STATIONARY_PRINTING,
      },
      {
        label: 'Signage / Billboards / Advertisement',
        value: LOGO_USE.ADVERTISING,
      },
      {
        label: 'Online Social Media',
        value: LOGO_USE.ONLINE_SOCIAL_MEDIA,
      },
      {
        label: 'T-Shirt Printing',
        value: LOGO_USE.TSHIRT_PRINTING,
      },
      {
        label: 'Car Wrap / Vinyls',
        value: LOGO_USE.CAR_WRAP,
      },
      {
        label: 'Embroidery',
        value: LOGO_USE.EMBROIDERY,
      },
      {
        label: 'Packaging',
        value: LOGO_USE.PACKAGING,
      },
      {
        label: 'App Icon',
        value: LOGO_USE.APP_ICON,
      },
      {
        label: 'Flyer / Brochure',
        value: LOGO_USE.FLYER,
      },
      {
        label: 'Other',
        value: LOGO_USE.OTHER,
      },
    ],
  },
  [FIELDS_KEYS.logoUseDescription]: {
    name: FIELDS_KEYS.logoUseDescription,
    label: 'Provide where the LOGO will be used:',
  },
  [FIELDS_KEYS.trademarkAssessment]: {
    name: FIELDS_KEYS.trademarkAssessment,
  },
};

export const getFieldProps = (fieldKey, { validationOptions } = {}) => {
  const props = fieldProps[fieldKey];
  return props
    ? { ...props, rules: getValidationRules(fieldKey, validationOptions) }
    : {};
};
